import synclounge from './synclounge';
import settings from './settings';
import plex from './plex';
import plexclients from './plexclients';
import plexservers from './plexservers';
import slplayer from './slplayer';
import rooms from './rooms';

export default {
  synclounge,
  plex,
  plexclients,
  plexservers,
  settings,
  slplayer,
  rooms,
};
